<template lang="pug">
    v-card.no-padding(outlined tile v-if="renderCustomerProfile && currentUserActivatedAccountMatchesCustomerAccount")
        v-toolbar(color="var(--off-white)" light dense)
            v-btn.mr-sm-2(color="var(--white)" light small v-if="validExit" @click="exit();")
                | Exit
                v-icon
                    | mdi-close
            v-icon(style="margin-right: 5px;") mdi-account
            v-toolbar-title 
                | {{ currentCampaignCustomer.customer.full_name }}
            v-spacer
            SimulatorDialog(
                v-if="currentCampaignCustomer"
                enrollable-type="Customer"
                :customer="currentCampaignCustomer"
                :source="source"
            )
            SharedLinksDialog(
                v-if="renderSharedLinks"
                :account-id="currentCampaignCustomer.account_id"
                :auto-create="autoCreateSharedLink"
                component="customer_profile"
                :shareable-id="currentCampaignCustomer.customer_id"
                shareable-type="customer"
                :share-button-classes="shareButtonClassesForSharedLinkDialog"
            )
            SkipRecord(
                v-if="renderSkipRecord"
                :call-id="callId"
                :current-campaign-customer="currentCampaignCustomer"
                :handle-skipped-campaign-customer="handleSkippedCampaignCustomer"
            )
            SaveForLater(
                v-if="renderSaveForLater"
                :communication-type="communicationType"
                :current-campaign-customer="currentCampaignCustomer"
                :show-snackbar="showSnackbar"
                :unassign-campaign-customer-active="unassignCampaignCustomerActive"
            )
            ScheduledCommunicationDetails(
                v-if="renderScheduledCommunicationDetails"
                :scheduled-communication-id="currentScheduledCommunicationID"
            )
            VoiceMailRecordingDialog(
                v-if="renderVoiceMailRecordingDetails"
                :call-id="callId"
                :end-voice-mail-recording="endVoiceMailRecording"
                :show-snackbar="showSnackbar"
                :start-force-start-next-dial="startForceStartNextDial"
                :voice-mail-recording="voiceMailRecording"
            )
            SavedPlaceInLineDialog(
                v-if="renderSavedPlaceDialog"
                :saved-place-in-line-call="pendingSavedPlaceCall"
            )
            v-btn.white--text(
                v-if="renderCompleteCampaignCustomerActive"
                @click="completeCampaignCustomerActive"
                color="warning"
                :disabled="completeButtonDisabled"
                small
            )
                v-icon mdi-check
                | Complete
        template(v-if="isPulseEnrollment && isPulseEnabled")
            NoticeBanner(gradient-variant="pulse" :opacity="0.3" :is-dismissable="true")
                template(v-slot:default)
                    div.pulse-enrollment-content
                        PulseColorIcon(:size="32")
                        | This customer was enrolled by Pulse.
                        //- add enrollment reason?
        v-row(
            no-gutters
            v-bind:style="{ height: cardBodyHeight + 'px' }"
        )

            v-col.col-right-divider(cols='6')
                v-tabs(grow show-arrows light v-model="leftCurrentTab")
                    template(v-if="leftItems && leftItems.length > 2")
                        v-tab(v-for='item in leftItems' :key='item.key' :href='"#" + item.href' class="left-contact-tab")
                            v-tooltip(top)
                                template(v-slot:activator='{ on, attrs }')
                                    span(v-bind="attrs" v-on="on" role="text")
                                        v-icon {{item.icon}}
                                span {{ item.name }}
                    template(v-else)
                        v-tab(v-for='item in leftItems' :key='item.key' :href='"#" + item.href' class="left-contact-tab")
                            | {{ item.name }}

                v-tabs-items(v-model="leftCurrentTab")
                    CustomerTab.overflow-y-auto(
                        v-show="leftCurrentTab === 'customer-tab'"
                        :audio-email-incoming="audioEmailIncoming"
                        :audio-email-outcoming="audioEmailOutcoming"
                        :current-campaign-customer="currentCampaignCustomer"
                        v-bind:style="{ height: tabContentHeight + 'px' }"
                        :call="call"
                        :communication-type="communicationType"
                        :force-subscription-changes-response="forceSubscriptionChangesResponse"
                        :activate-notes-icon-clicked="activateNotesIconClicked"
                        :handle-update-current-campaign-customer="handleUpdateCurrentCampaignCustomer"
                        :hide-create-update-destroy-buttons="hideCreateUpdateDestroyButtons"
                        :in-communication-center="inCommunicationCenter"
                        :is-manual-mode="isManualMode"
                        :is-rac-online="isRacOnline"
                        :is-saved-place-call="isSavedPlaceCall"
                        :parent-height="tabContentHeight"
                        :switch-campaign-for-campaign-customer-active="switchCampaignForCampaignCustomerActive"
                        :set-communication-manager="setCommunicationManager"
                        :source="source"
                        :start-switch-customer="startSwitchCustomer"
                        :switch-organization-for-campaign-customer-active="switchOrganizationForCampaignCustomerActive"
                        :tab-integration="currentTabIntegration"
                    )
                    template(v-if="campaignCustomerActiveID > 0")
                        DispositionTab.overflow-y-auto(
                            :is-live-dash-inbound-call="isLiveDashInboundCall"
                            :style="{ height: tabContentHeight + 'px', display: leftCurrentTab === 'disposition-tab' ? 'block' : 'none' }"
                            :add-saved-communication-disposition="addSavedCommunicationDisposition"
                            :autobuy-communication-disposition="autobuyCommunicationDisposition"
                            :appointment-is-unique-if-required="appointmentIsUniqueIfRequired"
                            :call-failed="callFailed"
                            :call-id="callId"
                            :call-transfer="callTransfer"
                            :campaign-disposition-to-survey="campaignDispositionToSurvey"
                            :communication-manager="communicationManager"
                            :communication-type="communicationType"
                            :create-agent="createAgent"
                            :create-survey-attempt="createSurveyAttempt"
                            :current-campaign-customer="currentCampaignCustomer"
                            :saved-communication-dispositions="savedCommunicationDispositions"
                            :finish-save-and-next-overlay="finishSaveAndNextOverlay"
                            :initiate-create-communication-disposition="initiateCreateCommunicationDisposition"
                            :is-manual-mode="isManualMode"
                            :is-paused-voice-mail-recording="isPausedVoiceMailRecording"
                            :is-tekion-enabled="isTekionEnabled"
                            :missed-call-from-call-screen="missedCallFromCallScreen"
                            :open-tekion-integration-tab="openTekionIntegrationTab"
                            :parent-disposition-notes="parentDispositionNotes"
                            :pending-saved-place-call="pendingSavedPlaceCall"
                            :reinit-integration-customers="reinitIntegrationCustomers"
                            :reset-campaign-disposition-to-survey="resetCampaignDispositionToSurvey"
                            :reset-saved-communication-dispositions="resetSavedCommunicationDispositions"
                            :render-integration-appointment-scheduler="renderIntegrationAppointmentScheduler"
                            :set-appointment-is-unique-if-required="setAppointmentIsUniqueIfRequired"
                            :set-campaign-dispositions="setCampaignDispositions"
                            :set-change-on-current-campaign-customer="setChangeOnCurrentCampaignCustomer"
                            :set-integration-appointment-details="setIntegrationAppointmentDetails"
                            :set-is-okay-to-create-communication-disposition="setIsOkayToCreateCommunicationDisposition"
                            :set-is-okay-to-save-and-next="setIsOkayToSaveAndNext"
                            :set-is-okay-to-survey-saved-disposition="setIsOkayToSurveySavedDisposition"
                            :set-selected-campaign-disposition="setSelectedCampaignDisposition"
                            :set-subscription-changes-on-communication-manager="setSubscriptionChangesOnCommunicationManager"
                            :select-most-used-disposition="leftCurrentTab === 'disposition-tab'"
                            :show-snackbar="showSnackbar"
                            :start-save-and-next="startSaveAndNext"
                            :sync-disposition-notes="syncDispositionNotes"
                            :integration-appointment-details="integrationAppointmentDetails"
                            :voice-mail-recording="voiceMailRecording"
                        )
                            
                    CommunicationPreferences.overflow-y-auto(
                        v-show="leftCurrentTab === 'customer-preferences-tab'"
                        v-bind:style="{ height: tabContentHeight + 'px' }"
                        :customer-communication-manager="communicationManager"
                        :current-campaign-customer="currentCampaignCustomer"
                        :hide-create-update-destroy-buttons="hideCreateUpdateDestroyButtons"
                        :in-communication-center="inCommunicationCenter"
                        :is-shown="leftCurrentTab === 'customer-preferences-tab'"
                        :set-communication-manager="setCommunicationManager"
                        :show-snackbar="showSnackbar"
                    )
                    ProspectsTab.overflow-y-auto(
                        v-if="leftCurrentTab === 'prospects-tab'"
                        :current-campaign-customer="currentCampaignCustomer"
                        v-bind:style="{ height: tabContentHeight + 'px' }"
                    )
                    TimelineTab.overflow-y-auto(
                        v-if="leftCurrentTab === 'timeline-tab'"
                        :customer-id="currentCampaignCustomer.customer_id"
                        :hide-pulse-events="!isPulseEnabled"
                        :organization-id="currentCampaignCustomer.organization_id"
                        :source="source"
                        v-bind:style="{ height: tabContentHeight + 'px' }"
                    )

            v-col.col-left-divider(cols='6')
                v-tabs(grow show-arrows light v-model='rightCurrentTab')
                    v-tab(v-for='item in rightItems' :key='item.key' :href='"#" + item.href')
                        img.tab-image.mr-2(v-if="item.image" :src="item.image" :alt="item.name")
                        | {{ item.name }}
                    v-menu(v-if='rightMore.length > 0' bottom left)
                        template(v-slot:activator='{ on }')
                            v-btn.align-self-center.mr-4(text v-on='on')
                                | more
                                v-icon(right) mdi-menu-down
                        v-list(color="var(--off-white)")
                            v-list-item(v-for='item in rightMore' :key='item.key' @click='addRightItem(item)')
                                | {{ item.name }}

                v-tabs-items
                    AppointmentHistoryTab.overflow-y-auto(
                        v-if="rightCurrentTab === 'appointment-history-tab'"
                        :current-campaign-customer="currentCampaignCustomer"
                        :current-user="currentUser"
                        v-bind:style="{ height: tabContentHeight + 'px' }"
                        :show-snackbar="showSnackbar"
                    )
                    CampaignEnrollmentHistoryTab.overflow-y-auto(
                        v-if="rightCurrentTab === 'campaign-enrollment-history-tab'"
                        :current-campaign-customer="currentCampaignCustomer"
                        v-bind:style="{ height: tabContentHeight + 'px' }"
                    )
                    CommunicationDispositionsTab.overflow-y-auto(
                        v-if="rightCurrentTab === 'communication-dispositions-tab'"
                        :current-campaign-customer="currentCampaignCustomer"
                        :set-change-on-current-campaign-customer="setChangeOnCurrentCampaignCustomer"
                        v-bind:style="{ height: tabContentHeight + 'px' }"
                    )
                    CommunicationHistoryTab.overflow-y-auto(
                        v-if="rightCurrentTab === 'communication-history-tab'"
                        :current-campaign-customer="currentCampaignCustomer"
                        :source="source"
                        v-bind:style="{ height: tabContentHeight + 'px' }"
                    )

                    keep-alive
                        AutobuyCrmTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'autobuy-tab'"
                            :current-campaign-customer="currentCampaignCustomer"
                            :on-autobuy-communication-disposition-change="onAutobuyCommunicationDispositionChange"
                            :show-snackbar="showSnackbar"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        CarlieDetails.overflow-y-auto.pa-4(
                            v-if="rightCurrentTab === 'carlie-tab' && carlieTab"
                            :ai-communication-id="carlieTab.aiCommunicationId"
                            :context="carlieTab.context"
                            :initial-details="carlieTab.details"
                            :live-analysis="carlieTab.analysis"
                            :recording-url="voiceMailRecording?.recording_url || ''"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        ContactsTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'contacts-tab'"
                            :call-id="callId"
                            :end-call="endCall"
                            :on-call="onCall"
                            :open-transfer-dialog="openTransferDialog"
                            :organization-id="currentCampaignCustomer.organization_id"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        CustomFieldsTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'custom-fields-tab'"
                            :account-id="currentCampaignCustomer.account_id"
                            :campaign-customer-id="currentCampaignCustomer.campaign_customer_id"
                            :customer-id="currentCampaignCustomer.customer_id"
                            :hide-create-update-destroy-buttons="hideCreateUpdateDestroyButtons"
                            :organization-id="currentCampaignCustomer.organization_id"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        CustomerVehiclesTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'customer-vehicles-tab'"
                            :current-campaign-customer="currentCampaignCustomer"
                            :hide-create-update-destroy-buttons="hideCreateUpdateDestroyButtons"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                            :change-tab="goToToyoguardTab"
                            :in-communication-center="inCommunicationCenter"
                        )
                        EleadTab.overflow-y-auto(
                            v-if="isEleadEnabled && rightCurrentTab === 'elead-tab'"
                            :current-campaign-customer="currentCampaignCustomer"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        ExternalLinksTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'external-links-tab'"
                            :campaign-id="currentCampaignCustomer.campaign_id"
                            :customer-id="currentCampaignCustomer.customer_id"
                            :organization-id="currentCampaignCustomer.organization_id"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        ForteTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'forte-tab'"
                            :current-campaign-customer="currentCampaignCustomer"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        GMROHistory.overflow-y-auto(
                            v-if="isGmBacEnabled && rightCurrentTab === 'gm-bac-tab'"
                            :current-campaign-customer="currentCampaignCustomer"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        InlineTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'inline-tab'"
                            :current-campaign-customer="currentCampaignCustomer"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        OrganizationTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'organization-tab'"
                            :campaign-id="currentCampaignCustomer.campaign_id"
                            :organization-id="currentCampaignCustomer.organization_id"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        PromotionsTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'promotions-tab'"
                            :campaign-id="currentCampaignCustomer.campaign_id"
                            :customer-id="currentCampaignCustomer.customer_id"
                            :organization-id="currentCampaignCustomer.organization_id"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        PulseAssessmentsTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'pulse-assessments-tab'"
                            :current-campaign-customer="currentCampaignCustomer"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        RasaniPingPostTab.overflow-y-auto(
                            v-if="isRasaniEnabled && rightCurrentTab === 'rasani-ping-post-tab'"
                            :call-id="callId"
                            :current-campaign-customer="currentCampaignCustomer"
                            :end-call="endCall"
                            :on-call="onCall"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )                        
                        ResourceNotesTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'customer-notes-tab'"
                            :current-campaign-customer="currentCampaignCustomer"
                            :current-user="currentUser"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        SalesTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'sales-tab'"
                            :current-campaign-customer="currentCampaignCustomer"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        ScheduledCommunicationsTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'scheduled-communications-tab'"
                            :current-campaign-customer="currentCampaignCustomer"
                            :hide-create-update-destroy-buttons="hideCreateUpdateDestroyButtons"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        ServicesTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'services-tab'"
                            :current-campaign-customer="currentCampaignCustomer"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        //- 12/4/2025 - Turning off integration appointment scheduler for now due to hitting rate limits
                        //- IntegrationTab.overflow-y-auto(
                        //-     v-if="rightCurrentTab === 'tekion-tab' && isTekionEnabled && renderIntegrationAppointmentScheduler"
                        //-     :is-communication-manager-set="isCommunicationManagerSet"
                        //-     :customer-communication-info="buildIntegrationCustomerCommunicationInfo"
                        //-     current-integration="tekion"
                        //-     :current-campaign-customer="currentCampaignCustomer"
                        //-     :in-communication-center="inCommunicationCenter"
                        //-     v-bind:style="{ height: tabContentHeight + 'px' }"
                        //-     :source="lastRightCurrentTab"
                        //-     :set-appointment-id-for-integration="setAppointmentIdForIntegration"
                        //-     :set-integration-appointment-details="setIntegrationAppointmentDetails"

                        //-     :set-integration-customer-sid="setIntegrationCustomerSid"
                        //-     :toggle-run-get-integrations-customers="toggleRunGetIntegrationsCustomers"
                        //- )
                        //- IntegrationTab.overflow-y-auto(
                        //-     v-if="rightCurrentTab === 'xtime-tab' && isXtimeEnabled && renderIntegrationAppointmentScheduler"
                        //-     :is-communication-manager-set="isCommunicationManagerSet"
                        //-     :customer-communication-info="buildIntegrationCustomerCommunicationInfo"
                        //-     current-integration="xtime"
                        //-     :current-campaign-customer="currentCampaignCustomer"
                        //-     :in-communication-center="inCommunicationCenter"
                        //-     v-bind:style="{ height: tabContentHeight + 'px' }"
                        //-     :source="lastRightCurrentTab"
                        //-     :set-appointment-id-for-integration="setAppointmentIdForIntegration"
                        //-     :set-integration-appointment-details="setIntegrationAppointmentDetails"
                        //-     :set-integration-customer-sid="setIntegrationCustomerSid"
                        //-     :toggle-run-get-integrations-customers="toggleRunGetIntegrationsCustomers"
                        //- )
                        TelematicAlertsTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'telematic-alerts-tab'"
                            :customer-id="customerID"
                            :current-campaign-customer="currentCampaignCustomer"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        ToyoguardTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'toyoguard-tab'"
                            :current-campaign-customer="currentCampaignCustomer"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        VehicleInventoryTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'vehicle-inventories-tab'"
                            :organization-id="currentCampaignCustomer.organization_id"
                            :force-organization-users="organizationUsers"
                            inventory-status="in_stock"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        VinSolutionsTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'vin-solutions-tab'"
                            :current-campaign-customer="currentCampaignCustomer"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )
                        AutoAssistantTab.overflow-y-auto(
                            v-if="rightCurrentTab === 'auto-assistant-tab'"
                            :call-id="callId"
                            :customer-id="customerID"
                            :in-communication-center="inCommunicationCenter"
                            :auto-assist-data="autoAssistData"
                            :transferred-from-auto-assist="hasAutoAssistData"
                            v-bind:style="{ height: tabContentHeight + 'px' }"
                        )

    v-alert( v-else-if="renderCustomerProfile && !currentUserActivatedAccountMatchesCustomerAccount" outlined type='warning' dense border='left' style="margin-top: 0px; max-height: 41px !important; background-color: white !important;")
        | User account does not match customer account

</template>

<script lang="ts">
    import Vue from 'vue';
    import VolieState from '@/store';

    // Components
    import AppointmentHistoryTab from '@/components/communication_center/shared/tabs/appointment_history.vue';
    import AutoAssistantTab from '@/components/communication_center/shared/tabs/auto_assistant.vue';
    import AutobuyCrmTab from '@/components/communication_center/shared/tabs/autobuy_crm.vue';
    import CampaignEnrollmentHistoryTab from '@/components/communication_center/shared/tabs/campaign_enrollment_history.vue';
    import CarlieDetails from '@/components/carlie/carlie_details.vue';
    import CommunicationDispositionsTab from '@/components/communication_center/shared/tabs/communication_dispositions.vue';
    import CommunicationHistoryTab from '@/components/communication_center/shared/tabs/communication_history.vue';
    import CommunicationPreferences from '@/components/communication_center/shared/tabs/communication_preferences.vue';
    import ContactsTab from '@/components/communication_center/shared/tabs/contacts.vue';
    import CustomerTab from '@/components/communication_center/shared/tabs/customer.vue';
    import CustomerVehiclesTab from '@/components/communication_center/shared/tabs/customer_vehicles.vue';
    import CustomFieldsTab from '@/components/communication_center/shared/tabs/custom_fields.vue';
    import ResourceNotesTab from '@/components/communication_center/shared/tabs/resource_notes.vue';
    import DispositionTab from '@/components/communication_center/shared/tabs/disposition.vue';
    import EleadTab from '@/components/communication_center/shared/tabs/elead.vue';
    import ExternalLinksTab from '@/components/communication_center/shared/tabs/external_links.vue';
    import ForteTab from '@/components/communication_center/shared/tabs/forte_crm.vue';
    import GMROHistory from '@/components/communication_center/shared/tabs/gm_ro_history.vue';
    import InlineTab from '@/components/communication_center/shared/tabs/inline_crm.vue';
    import NoticeBanner from '@/components/shared/notice-banner.vue';
    import OrganizationTab from '@/components/communication_center/shared/tabs/organization.vue';
    import PromotionsTab from '@/components/communication_center/shared/tabs/promotions.vue';
    import ProspectsTab from '@/components/communication_center/shared/tabs/prospects.vue';
    import PulseAssessmentsTab from '@/components/communication_center/shared/tabs/pulse_assessments.vue';
    import PulseColorIcon from '@/components/scorecards/pulse_color_icon.vue';
    import RasaniPingPostTab from '@/components/communication_center/shared/tabs/rasani_ping_post.vue';
    import SalesTab from '@/components/communication_center/shared/tabs/sales.vue';
    import SaveForLater from '@/components/communication_center/shared/save_for_later.vue';
    import SavedPlaceInLineDialog from '@/components/communication_center/shared/saved_place_in_line_dialog.vue';
    import ScheduledCommunicationDetails from '@/components/scheduled_communications/details_dialog.vue';
    import ScheduledCommunicationsTab from '@/components/communication_center/shared/tabs/scheduled_communications.vue';
    import ServicesTab from '@/components/communication_center/shared/tabs/services.vue';
    import SharedLinksDialog from '@/components/shared_links/dialog.vue';
    import SimulatorDialog from '@/components/enroller_runs/simulator/simulator_dialog.vue';
    import SkipRecord from '@/components/communication_center/shared/skip_record.vue';
    import IntegrationTab from '@/components/communication_center/shared/tabs/integration.vue';
    import VinSolutionsTab from '@/components/communication_center/shared/tabs/vin_solutions.vue';
    import TelematicAlertsTab from '@/components/communication_center/shared/tabs/telematic_alerts.vue';
    import TimelineTab from '@/components/customers/timeline.vue';
    import ToyoguardTab from '@/components/communication_center/shared/tabs/toyoguard.vue';
    import VehicleInventoryTab from '@/components/communication_center/shared/tabs/vehicle_inventories.vue';
    import VoiceMailRecordingDialog from '@/components/voice_mail_recordings/dialog.vue';


    // Helpers
    import { carlieTabSource } from '@/helpers/carlie';
    import {
        getInCommunicationCenterCustomerProfileLeftTabs,
        getNonCommunicationCenterCustomerProfileLeftTabs,
        getCustomerProfileRightTabs,
    } from '@/helpers/customer_profile';
    export default Vue.extend({
        data() {
            return {
                autobuyCommunicationDisposition: null,
                cardBodyHeight: null,
                forceSubscriptionChangesResponse: null,
                isPulseEnrollment: false,
                lastRightCurrentTab: null,
                leftCurrentTab: null,
                leftItems: [],
                rightCurrentTab: null,
                rightItems: [],
                rightMore: [],
                tabContentHeight: null,
                toyoguardEnabled: false,
                integrationAppointmentDetails: null,
                allowedIntegrations: ['tekion', 'xtime'],
                toggleRunGetIntegrationsCustomers: false,
            }
        },
        methods: {
            addRightItem (item) {
                const removed = this.rightItems.splice(0, 1);
                this.rightItems.push(
                    ...this.rightMore.splice(this.rightMore.indexOf(item), 1)
                );
                this.rightMore.push(...removed);
                this.rightMore.sort((a, b) => {
                    if (a.name < b.name) {
                        return -1
                    }
                    if (a.name > b.name) {
                        return 1
                    }
                    return 0
                });

                this.rightCurrentTab = item.href;
            },
            goToToyoguardTab() {
                this.rightMore.forEach((item) => {
                    if (item.key === 'toyoguard') {
                        this.addRightItem(item);
                    }
                });
            },
            handleWindowResize() {

                // Declare constants
                const paddingPx = 2;
                const toolbarHeight = 48;
                const noticeBannerHeight = 52;
                const tabBarHeight = 48;
                const colPaddingAndMargin = 47.109;

                // Calcuate
                this.cardBodyHeight = this.customerProfileHeight - paddingPx - toolbarHeight;
                this.tabContentHeight = this.cardBodyHeight - tabBarHeight - colPaddingAndMargin;

                if (this.isPulseEnrollment) {
                    this.cardBodyHeight = this.cardBodyHeight - noticeBannerHeight;
                    this.tabContentHeight = this.tabContentHeight - noticeBannerHeight;
                }
            },
            handleIsPulseEnrollment() {
                if (!this.currentCampaignCustomer) {
                    return;
                }

                if (this.currentCampaignCustomer?.eventable_type === 'LlmAssessment') {
                    if (!this.isPulseEnabled) {
                        return;
                    }
                    this.isPulseEnrollment = true;
                    // Pulse tab may be in rightMore (hidden); add it to visible rightItems first so v-tabs can select it
                    const pulseTab = this.rightMore.find(item => item.key === 'pulse-assessments');
                    if (pulseTab) {
                        this.addRightItem(pulseTab);
                    }
                    this.rightCurrentTab = 'pulse-assessments-tab';
                    this.handleWindowResize();
                }
            },
            handleIsTelematicAlertEnrollment() {
                if (!this.currentCampaignCustomer) {
                    return;
                }

                if (this.currentCampaignCustomer?.has_telematic_alert_type_mapping) {
                    // Telematic Alerts tab may be in rightMore (hidden); add it to visible rightItems first so v-tabs can select it
                    const telematicAlertsTab = this.rightMore.find(item => item.key === 'telematic_alerts');
                    if (telematicAlertsTab) {
                        this.addRightItem(telematicAlertsTab);
                    }
                    this.rightCurrentTab = 'telematic-alerts-tab';
                }
            },
            onAutobuyCommunicationDispositionChange(autobuyCommunicationDisposition) {

                // Verify
                if (!autobuyCommunicationDisposition) {
                    return;
                }

                // Set
                this.autobuyCommunicationDisposition = autobuyCommunicationDisposition;
            },
            activateNotesIconClicked() {
                const resourceNotesTab = this.rightMore.find(item => item.key === 'resource_notes');
                if (resourceNotesTab) {
                    this.addRightItem(resourceNotesTab);
                } else {
                    this.rightCurrentTab = 'resource-notes-tab';
                }
            },
            openTekionIntegrationTab() {
                // Find the Tekion tab in rightMore and move it to rightItems if needed
                const tekionTab = this.rightMore.find(item => item.key === 'tekion');
                if (tekionTab) {
                    this.addRightItem(tekionTab);
                } else {
                    this.rightCurrentTab = 'tekion-tab';
                }
            },
            reinitIntegrationCustomers() {
                this.toggleRunGetIntegrationsCustomers = !this.toggleRunGetIntegrationsCustomers;
            },
            setCustomerProfileLeftMoreTabs() {

                // If we aren't in communication center, just give them the customer info and prospect tab (we don't care about default tab here since we are actually on the show page)
                if (!this.inCommunicationCenter) {
                    this.leftItems = getNonCommunicationCenterCustomerProfileLeftTabs();
                    this.leftCurrentTab = this.leftItems[0].href;
                    return;
                }

                const leftTabs = getInCommunicationCenterCustomerProfileLeftTabs();

                // set default tab
                const systemDefaultTab = "customer";
                let defaultTab = systemDefaultTab;

                // Check account user default
                if (this.currentUser?.account_user?.default_left_tab_on_communication_center?.length > 0) {
                    defaultTab = this.currentUser.account_user.default_left_tab_on_communication_center;
                }

                // if default tab setting is a hidden tab determine which tab should be open
                if (this.hiddenTabs?.includes(defaultTab)) {

                    // reset to system default tab if system default not hidden
                    if (!this.hiddenTabs?.includes(systemDefaultTab)) {
                        defaultTab = systemDefaultTab;
                    } else { // if system default tab is hidden then open to first available tab alphabetically
                        for (let i = 0; i < leftTabs.length; i++) {
                            if (!this.hiddenTabs?.includes(leftTabs[i].key)) {
                                defaultTab = leftTabs[i].key;
                                break;
                            }
                        }
                    }
                }

                // filter out hidden tabs
                const permittedTabs = [];
                for (let i = 0; i < leftTabs.length; i++) {
                    if (!this.hiddenTabs?.includes(leftTabs[i].key)) {
                        permittedTabs.push(leftTabs[i]);
                    }
                }

                this.leftItems = permittedTabs;

                for (let i = 0; i < permittedTabs.length; i++) {
                    if (permittedTabs[i].key === defaultTab) {
                        this.leftCurrentTab = permittedTabs[i].href;
                        break;
                    }
                }

                return;

            },
            setCustomerProfileRightMoreTabs() {
                this.rightMore = [];
                this.rightItems = [];
                this.rightCurrentTab = null;

                const options = {
                    autobuyCrmEnabled: this.isAutobuyCrmEnabled,
                    autoAssistantEnabled: this.isAutoAssistantEnabled,
                    autoAssistantName: this.hasAutoAssistData ? this.autoAssistData?.auto_assistant_type || "" : "",
                    forteCrmEnabled: this.isForteCrmEnabled,
                    gmBacEnabled: this.isGmBacEnabled,
                    hasAutoAssist: this.hasAutoAssistData,
                    inCommunicationCenter: this.inCommunicationCenter,
                    inlineCrmEnabled: this.isInlineCrmEnabled,
                    isCarlieCall: !!this.carlieTab,
                    eleadEnabled: this.isEleadEnabled,
                    rasaniEnabled: this.isRasaniEnabled,
                    pulseEnabled: this.isPulseEnabled,
                    renderIntegrationAppointmentScheduler: this.renderIntegrationAppointmentScheduler,
                    tekionEnabled: this.isTekionEnabled,
                    toyoguardEnabled: this.isToyoguardEnabled,
                    vinSolutionsEnabled: this.isVinEnabled,
                    xtimeEnabled: this.isXtimeEnabled,
                }

                const rightTabs = getCustomerProfileRightTabs(options);

                // set default tab
                const systemDefaultTab = "communication_history";
                let defaultTab = systemDefaultTab;

                // Check integration tabs
                if (this.isAutobuyCrmEnabled) {
                    defaultTab = "autobuy";
                } else if (this.isForteCrmEnabled) {
                    defaultTab = "forte";
                } else if (this.isInlineCrmEnabled) {
                    defaultTab = "inline";
                } else if (this.isGmBacEnabled) {
                    defaultTab = 'gm-bac'
                } else {

                    // Check account user default
                    if (this.currentUser?.account_user?.default_right_tab_on_communication_center?.length > 0) {
                        defaultTab = this.currentUser.account_user.default_right_tab_on_communication_center;
                    }

                    // if the preferred default tab is no longer available (e.g., disabled account-wide), fall back to system default
                    const availableTabKeys = rightTabs.map(t => t.key);
                    if (!availableTabKeys.includes(defaultTab)) {
                        defaultTab = systemDefaultTab;
                    }

                    // if default tab setting is a hidden tab determine which tab should be open
                    if (this.hiddenTabs?.includes(defaultTab)) {

                        // reset to system default tab if system default not hidden
                        if (!this.hiddenTabs?.includes(systemDefaultTab)) {
                            defaultTab = systemDefaultTab;
                        } else { // if system default tab is hidden then open to first available tab alphabetically
                            for (let i = 0; i < rightTabs.length; i++) {
                                if (!this.hiddenTabs?.includes(rightTabs[i].key)) {
                                    defaultTab = rightTabs[i].key;
                                    break;
                                }
                            }
                        }
                    }
                }

                if (this.hasAutoAssistData) {
                    defaultTab = 'auto-assistant'
                }

                if (this.carlieTab) {
                    defaultTab = 'carlie';
                }

                // filter out hidden tabs
                const permittedTabs = [];
                for (let i = 0; i < rightTabs.length; i++) {
                    if (!this.hiddenTabs?.includes(rightTabs[i].key)) {
                        permittedTabs.push(rightTabs[i]);
                    }
                }

                // if 2 or less tabs
                if (permittedTabs.length <= 2) {
                    this.rightItems = permittedTabs;

                    for (let i = 0; i < permittedTabs.length; i++) {
                        if (permittedTabs[i].key === defaultTab) {
                            this.rightCurrentTab = permittedTabs[i].href;
                            break;
                        }
                    }

                    return;
                }

                // if 3 or more tabs
                for (let i = 0; i < permittedTabs.length; i++) {
                    if (permittedTabs[i].key === defaultTab) {
                        this.rightCurrentTab = permittedTabs[i].href;
                        this.rightItems = [permittedTabs[i]];
                    } else {
                        this.rightMore.push(permittedTabs[i]);
                    }
                }
            },
            setCustomerProfileTabs() {
                this.setCustomerProfileLeftMoreTabs();
                this.setCustomerProfileRightMoreTabs();
            },
            setSubscriptionChangesOnCommunicationManager(response) {
                this.forceSubscriptionChangesResponse = { ...response };
            },
            setIntegrationAppointmentDetails(integrationAppointmentDetails, setToNull = false) {
                // If setToNull is true, set the integration appointment details to null
                if (setToNull) {
                    this.integrationAppointmentDetails = null;
                    return;
                }

                // Otherwise, verify and set
                if (!integrationAppointmentDetails) {
                    return;
                }
                this.integrationAppointmentDetails = integrationAppointmentDetails;
            },
            setAppointmentIdForIntegration(appointmentId) {
                if (!appointmentId || appointmentId === 0) {
                    return;
                }

                this.integrationAppointmentDetails.appointment_id = appointmentId;
                return;
            },
        },
        computed: {
            autoCreateSharedLink() {
                return this.inCommunicationCenter;
            },
            campaignCustomerActiveID() {
                return this.currentCampaignCustomer?.campaign_customer_active_id;
            },
            completeButtonDisabled() {
                //TODO: change this if we ever add acknowledgement support for emails the 'complete' button only renders for these communication types
                switch (this.communicationType) {
                    case 'Email':
                        return !(this.currentCampaignCustomer?.total_communication_dispositions > 0)
                    case 'SMS Message':
                        return !(this.currentCampaignCustomer?.total_communication_dispositions > 0) && this.isAcknowledgeable;
                    default:
                        return false;
                }
            },
            currentScheduledCommunicationID() {
                return this.currentCampaignCustomer?.current_scheduled_communication_id;
            },
            currentUser() {
                return VolieState.currentUser();
            },
            currentUserActivatedAccountMatchesCustomerAccount() {
                if (this.currentUser === null) {
                    return true;
                }
                return this.currentUser?.activated_account_id > 0 && this.currentUser?.activated_account_id === this.currentCampaignCustomer?.customer?.account_id;
            },
            currentUserIsSuperAdmin() {
                return this.currentUser?.activated_role_id === 1;
            },
            customerID() {
                return this.currentCampaignCustomer?.customer_id;
            },
            hiddenTabs() {
                if (this.currentUser?.account_user?.hidden_tabs?.length > 0) {
                    return this.currentUser.account_user.hidden_tabs;
                }

                return [];
            },
            isAutobuyCrmEnabled() {
                return this.currentUser?.account?.autobuy_crm_enabled === true && this.isValidCampaignCustomerActive;
            },
            isAutoAssistantEnabled() {
                return this.currentCampaignCustomer?.auto_assistant_enabled === true;
            },
            isEleadEnabled() {
                return this.isValidCampaignCustomerActive && this.currentCampaignCustomer?.elead_enabled === true;
            },
            isForteCrmEnabled() {
                return this.currentUser?.account?.forte_crm_enabled === true && this.isValidCampaignCustomerActive && this.currentCampaignCustomer?.forte_crm_key_id > 0;
            },
            isInlineCrmEnabled() {
                return this.currentUser?.account?.inline_crm_enabled === true && this.isValidCampaignCustomerActive && this.currentCampaignCustomer?.inline_crm_key?.length > 0;
            },
            isRasaniEnabled() {
                return this.currentUser?.account?.rasani_enabled === true;
            },
            isGmBacEnabled() {
                return this.currentUser?.account?.gm_ro_history_enabled === true && this.isValidCampaignCustomerActive && this.currentCampaignCustomer?.gm_ro_bac_is_valid;
            },
            isPulseEnabled() {
                return this.currentUser?.account?.ai_communication_analysis_enabled === true
                    && this.currentUser?.account?.hide_pulse_tab !== true;
            },
            isTekionEnabled() {
                // 12/4/2025 - Turning off Tekion + xtime for now due to hitting rate limits
                // return this.currentCampaignCustomer?.tekion_enabled;
                return false;
            },
            isXtimeEnabled() {
                // 12/4/2025 - Turning off Tekion + xtime for now due to hitting rate limits
                // return this.currentCampaignCustomer?.xtime_enabled;
                return false;
            },
            isToyoguardEnabled() {
                return this.currentCampaignCustomer?.toyoguard_enabled;
            },
            isVinEnabled() {
                return this.currentUser?.need_vin_solutions_auth && this.currentCampaignCustomer?.vin_enabled;
            },
            isValidCampaignCustomerActive() {
                return this.inCommunicationCenter ? this.campaignCustomerActiveID > 0 : this.currentCampaignCustomer?.customer_id > 0;
            },
            renderCompleteCampaignCustomerActive() {
                return (this.communicationType === 'Email' || this.communicationType === 'SMS Message');
            },
            renderCustomerProfile() {
                return this.isValidCampaignCustomerActive;
            },
            renderIntegrationAppointmentScheduler() {
                // 12/4/2025 - Turning off integration appointment scheduler for now due to hitting rate limits
                // return this.currentCampaignCustomer?.is_integrations_api_calendar_ui_enabled && this.communicationType === 'Phone' && this.view === 'call_screen'; //TODO: V2 add email and sms + customer profile and other view, view specification is temporary
                return false;
            },
            renderSaveForLater() {
                return (this.communicationType === 'Email' || this.communicationType === 'SMS Message') && ((this.currentCampaignCustomer?.expiration_code || 0) !== 11);
            },
            renderSavedPlaceDialog() {
                return this.pendingSavedPlaceCall?.call_communication_queue?.call_communication_queue_id > 0
            },
            renderScheduledCommunicationDetails() {
                return this.currentScheduledCommunicationID > 0;
            },
            renderSharedLinks() {
                return this.currentUser?.account?.shared_links_enabled === true;
            },
            renderSkipRecord() {
                return this.isLockedAgentStatus !== true && this.communicationType === 'Phone' && !this.isManualMode && !this.callId && !this.voiceMailRecording;
            },
            renderVoiceMailRecordingDetails() {
                return this.voiceMailRecording?.voice_mail_recording_id > 0;
            },
            shareButtonClassesForSharedLinkDialog() {
                return this.inCommunicationCenter ? "mr-4" : null;
            },
            validExit() {
                return this.exit !== undefined && this.exit !== null;
            },
            carlieTab() {
                return carlieTabSource(this.carlieLiveHandoff, this.voiceMailRecording);
            },
            buildIntegrationCustomerCommunicationInfo() {
                // Primary IDs on the communication manager: primary_address_id, primary_email_address_id, phone_number_id

                // customer addresses
                let customerAddresses = []
                if (this.communicationManager?.customer_addresses?.length > 0) {
                    for (let i = 0; i < this.communicationManager?.customer_addresses?.length; i++) {
                        if (this.communicationManager?.customer_addresses[i].do_not_mail) {
                            continue;
                        }

                        let address = {
                            addressLine1: this.communicationManager?.customer_addresses[i].address_street_one,
                            addressLine2: this.communicationManager?.customer_addresses[i].address_street_two,
                            city: this.communicationManager?.customer_addresses[i].address_city,
                            state: this.communicationManager?.customer_addresses[i].address_region,
                            zipCode: this.communicationManager?.customer_addresses[i].address_postal_code,
                            country: this.communicationManager?.customer_addresses[i].address_country_iso_two,
                            isPrimary: this.communicationManager?.primary_address_id === this.communicationManager?.customer_addresses[i].address_id, // sets primary from primary_address_id on communication manager
                        }

                        // push to array of addresses
                        customerAddresses.push(address);
                    }

                    // Sort by isPrimary first (primary = true comes first)
                    customerAddresses.sort((a, b) => {
                        if (a.isPrimary && !b.isPrimary) return -1;
                        if (!a.isPrimary && b.isPrimary) return 1;
                        return 0;
                    });
                }

                // customer email addresses
                let customerEmailAddresses = []
                if (this.communicationManager?.customer_email_addresses?.length > 0) {
                    for (let i = 0; i < this.communicationManager?.customer_email_addresses?.length; i++) {
                        if (this.communicationManager?.customer_email_addresses[i].do_not_email) {
                            continue;
                        }

                        let emailAddress = {
                            emailAddress: this.communicationManager?.customer_email_addresses[i].email_address_email,
                            isPrimary: this.communicationManager?.primary_email_address_id === this.communicationManager?.customer_email_addresses[i].email_address_id, // sets primary from primary_email_address_id on communication manager
                        }

                        // push to array of email addresses
                        customerEmailAddresses.push(emailAddress);
                    }

                    // Sort by isPrimary first (primary = true comes first)
                    customerEmailAddresses.sort((a, b) => {
                        if (a.isPrimary && !b.isPrimary) return -1;
                        if (!a.isPrimary && b.isPrimary) return 1;
                        return 0;
                    });
                }

                // customer phone numbers
                let customerPhoneNumbers = []
                if (this.communicationManager?.customer_phone_numbers?.length > 0) {
                    for (let i = 0; i < this.communicationManager?.customer_phone_numbers?.length; i++) {
                        if (this.communicationManager?.customer_phone_numbers[i].do_not_call) {
                            continue;
                        }

                        let phoneNumber = {
                            phoneNumber: this.communicationManager?.customer_phone_numbers[i].phone_number_phone_number?.replace(/[()-]/g, ''),
                            phoneType: null,
                            isPrimary: false,
                        }

                        switch (this.communicationManager?.customer_phone_numbers[i].phone_number_type.toLowerCase()) {
                            case 'home':
                                phoneNumber.phoneType = 'home';
                                phoneNumber.isPrimary = this.communicationManager?.home_phone_id === this.communicationManager?.customer_phone_numbers[i].phone_number_id;
                                break;
                            case 'work':
                                phoneNumber.phoneType = 'work';
                                phoneNumber.isPrimary = this.communicationManager?.work_phone_id === this.communicationManager?.customer_phone_numbers[i].phone_number_id;
                                break;
                            case 'cell':
                                phoneNumber.phoneType = 'cell';
                                phoneNumber.isPrimary = this.communicationManager?.cell_phone_id === this.communicationManager?.customer_phone_numbers[i].phone_number_id;
                                break;
                            default:
                                phoneNumber.phoneType = 'other';
                                break;
                        }

                        // push to array of phone numbers
                        customerPhoneNumbers.push(phoneNumber);
                    }

                    // Sort by phone type (Home → Work → Cell), then by isPrimary, then alphabetically
                    customerPhoneNumbers.sort((a, b) => {
                        // Define phone type order
                        const phoneTypeOrder = { 'home': 1, 'work': 2, 'cell': 3 };
                        
                        // Get order values (default to 999 for unknown types)
                        const aOrder = phoneTypeOrder[a.phoneType] || 999;
                        const bOrder = phoneTypeOrder[b.phoneType] || 999;
                        
                        // First compare by phone type order
                        if (aOrder !== bOrder) {
                            return aOrder - bOrder;
                        }

                        // If phone types are equal, sort by isPrimary (true comes before false)
                        if (a.isPrimary && !b.isPrimary) return -1;
                        if (!a.isPrimary && b.isPrimary) return 1;

                        // If both have same phone type and isPrimary status, sort alphabetically by phone number
                        return (a.phoneNumber || '').localeCompare(b.phoneNumber || '');
                    });
                }

                const customerCommunicationInfo = {
                    customerFirstName: this.communicationManager?.first_name,
                    customerLastName: this.communicationManager?.last_name,
                    companyName: this.communicationManager?.company_name,
                    subscribedCommunicationTypeEmail: this.communicationManager?.subscribed_communication_type_email,
                    subscribedCommunicationTypePhone: this.communicationManager?.subscribed_communication_type_phone,
                    subscribedCommunicationTypeSMS: this.communicationManager?.subscribed_communication_type_sms,
                    customerAddresses: customerAddresses,
                    customerEmailAddresses: customerEmailAddresses,
                    customerPhoneNumbers: customerPhoneNumbers,
                };

                return customerCommunicationInfo;
            },
            currentTabIntegration() {
                if (this.rightCurrentTab === 'xtime-tab' && this.isXtimeEnabled) {
                    return 'Xtime';
                }
                
                if (this.rightCurrentTab === 'tekion-tab' && this.isTekionEnabled) {
                    return 'Tekion';
                }

                return "";
            },
        },
        components: {
            AppointmentHistoryTab,
            AutoAssistantTab,
            AutobuyCrmTab,
            CampaignEnrollmentHistoryTab,
            CarlieDetails,
            CommunicationDispositionsTab,
            CommunicationHistoryTab,
            ContactsTab,
            CustomerTab,
            CommunicationPreferences,
            CustomerVehiclesTab,
            CustomFieldsTab,
            ResourceNotesTab,
            DispositionTab,
            EleadTab,
            ExternalLinksTab,
            ForteTab,
            GMROHistory,
            InlineTab,
            NoticeBanner,
            OrganizationTab,
            PromotionsTab,
            ProspectsTab,
            PulseAssessmentsTab,
            PulseColorIcon,
            RasaniPingPostTab,
            SalesTab,
            SaveForLater,
            SavedPlaceInLineDialog,
            ScheduledCommunicationDetails,
            ScheduledCommunicationsTab,
            ServicesTab,
            SharedLinksDialog,
            SimulatorDialog,
            SkipRecord,
            IntegrationTab,
            TelematicAlertsTab,
            TimelineTab,
            ToyoguardTab,
            VehicleInventoryTab,
            VinSolutionsTab,
            VoiceMailRecordingDialog,
        },
        props: {
            addSavedCommunicationDisposition: Function,
            appointmentIsUniqueIfRequired: Boolean,
            autoAssistData: Object,
            audioEmailIncoming: HTMLAudioElement,
            audioEmailOutcoming: HTMLAudioElement,
            call: Object,
            callFailed: Boolean,
            callId: Number,
            callTransfer: Object,
            campaignDispositionToSurvey: Object,
            carlieLiveHandoff: Object,
            communicationManager: Object,
            isCommunicationManagerSet: Boolean,
            communicationType: String,
            completeCampaignCustomerActive: Function,
            createAgent: Function,
            createSurveyAttempt: Function,
            currentCampaignCustomer: Object,
            savedCommunicationDispositions: Array,
            customerProfileHeight: Number,
            endCall: Function,
            endVoiceMailRecording: Function,
            exit: Function,
            finishSaveAndNextOverlay: Function,
            hasAutoAssistData: Boolean,
            isAcknowledgeable: Boolean,
            hideCreateUpdateDestroyButtons: Boolean,
            inCommunicationCenter: Boolean,
            initiateCreateCommunicationDisposition: Boolean,
            isLockedAgentStatus: Boolean,
            isManualMode: Boolean,
            isPausedVoiceMailRecording: Boolean,
            isRacOnline: Boolean,
            isSavedPlaceCall: Boolean,
            isLiveDashInboundCall: Boolean,
            isSupervisor: Boolean,
            handleSkippedCampaignCustomer: Function,
            handleUpdateCurrentCampaignCustomer: Function,
            missedCallFromCallScreen: Boolean,
            onCall: Boolean,
            openTransferDialog: Function,
            organizationUsers: Array,
            parentDispositionNotes: String,
            pendingSavedPlaceCall: Object,
            switchCampaignForCampaignCustomerActive: Function,
            resetCampaignDispositionToSurvey: Function,
            resetSavedCommunicationDispositions: Function,
            setAppointmentIsUniqueIfRequired: Function,
            setCampaignDispositions: Function,
            setChangeOnCurrentCampaignCustomer: Function,
            setCommunicationManager: Function,
            setIntegrationCustomerSid: Function,
            setIsOkayToCreateCommunicationDisposition: Function,
            setIsOkayToSaveAndNext: Function,
            setIsOkayToSurveySavedDisposition: Function,
            setSelectedCampaignDisposition: Function,
            showSnackbar: Function,
            source: String,
            startForceStartNextDial: Function,
            startSaveAndNext: Function,
            startSwitchCustomer: Function,
            switchOrganizationForCampaignCustomerActive: Function,
            syncDispositionNotes: Function,
            unassignCampaignCustomerActive: Function,
            voiceMailRecording: Object,
            view: String,
        },
        destroyed() {
            window.removeEventListener('resize', this.handleWindowResize);
        },
        created() {
            window.addEventListener('resize', this.handleWindowResize);
            this.setCustomerProfileTabs();
        },
        mounted() {
            this.handleWindowResize();
            this.handleIsPulseEnrollment();
            this.handleIsTelematicAlertEnrollment();
        },
        watch: {
            customerProfileHeight() {
                Vue.nextTick(() => { this.handleWindowResize(); });
            },
            hasAutoAssistData: {
                handler(value) {
                    const tabPresent = this.rightItems.concat(this.rightMore).some((tab) => tab.key === 'auto-assistant');
                    if (value && !tabPresent) {
                        this.setCustomerProfileRightMoreTabs();
                    }
                },
            },
            rightCurrentTab(newValue, oldValue) {
                if (oldValue?.length > 0 && newValue !== oldValue) {
                    this.lastRightCurrentTab = oldValue;
                }
            },
            'carlieTab.context'(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.setCustomerProfileRightMoreTabs();
                }
            },
        },
    });
</script>

<style lang="scss" scoped>
    #app {
        .col-right-divider {
            border-right: 1px solid var(--off-white);
            margin-top: 1%;
            margin-bottom: 2%;
            padding: 10px 20px 10px 20px;
        }

        .col-left-divider {
            border-left: 1px solid var(--off-white);
            margin-top: 1%;
            margin-bottom: 2%;
            padding: 10px 20px 10px 20px;
        }

    }
    @media only screen and (min-width: 1264px) and (max-width: 1525px) {
        .left-contact-tab {
            font-size: 0.8vw;
        }
    }

    .pulse-enrollment-content {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        color: var(--volie-blue);
    }

    .tab-image {
        height: 18px;
        width: 18px;
    }
</style>
